var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassicMembershipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "118.000000pt",
    height: "109.000000pt",
    viewBox: "0 0 118.000000 109.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#A99268"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,109.000000) scale(0.100000,-0.100000)",
    fill: "#981B1E",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513 918 l-133 -111 0 -171 c-1 -191 -9 -249 -38 -278 -19 -20 -19     -20 -42 11 -64 91 -84 255 -43 358 27 68 81 140 132 178 35 26 54 55 35 55 -4     0 -34 -20 -68 -44 -218 -156 -288 -376 -187 -593 135 -288 534 -339 761 -96     33 35 60 68 60 73 0 22 -20 17 -56 -11 -60 -49 -157 -90 -232 -99 -37 -5 -70     -6 -74 -2 -3 4 -8 170 -10 370 -3 319 -1 362 12 358 8 -3 53 -19 100 -35 116     -41 127 -40 183 17 26 26 47 53 47 59 0 6 -30 14 -72 18 -40 4 -107 18 -148     31 -41 13 -79 24 -85 23 -5 0 -70 -50 -142 -111z m76 -560 c0 -93 -3 -168 -8     -168 -38 0 -148 47 -191 81 l-52 41 76 77 c48 48 80 89 86 111 6 19 10 110 10     202 l0 166 33 28 32 27 6 -199 c4 -109 7 -274 8 -366z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicMembershipIcon);
export default __webpack_public_path__ + "static/media/classic_membership_icon.4799b448ad264af465de2f7b1ff76444.svg";
export { ForwardRef as ReactComponent };